<template>
  <div class="login">
    <!-- 登录注册 -->
    <el-dialog
      :title="this.title+'用户注册'"
      custom-class="login-form"
      :visible.sync="registerFormVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
      <el-container v-if="registerFormVisible">
        <div class="reg">
          <el-tabs v-model="activeName">
            <el-tab-pane label="邮箱注册" name="emailSignUp">
              <el-form
                :model="registerFormEmail"
                status-icon
                :rules="rules"
                ref="registerFormEmail"
                style="min-height:250px"
              >
                <el-form-item prop="email">
                  <el-input type="text" v-model="registerFormEmail.email" placeholder="请输入邮箱"></el-input>
                </el-form-item>
                <el-form-item prop="pass">
                  <el-input
                    type="password"
                    v-model="registerFormEmail.pass"
                    placeholder="请输入密码"
                    auto-complete="new-password"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="checkPass">
                  <el-input
                    type="password"
                    v-model="registerFormEmail.checkPass"
                    placeholder="确认密码"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="code">
                  <el-row>
                    <!-- <el-col :span="16">
                      <el-input
                        v-model="registerFormEmail.code"
                        auto-complete="off"
                        placeholder="请输入图片验证码"
                        style="width: 100%"
                      ></el-input>
                    </el-col>
                    <el-col :span="8">
                      <div class="login-code" style="height: 50px;">
                        <img
                          :src="codeUrl"
                          @click="getCode"
                          class="login-code-img"
                          style="width:100%;height:50px;border-r"
                        />
                      </div>
                    </el-col>-->
                    <slide-verify
                      v-if="activeName === 'emailSignUp'"
                      :key="1"
                      :l="42"
                      :r="10"
                      :w="verifyWhite"
                      :h="150"
                      :imgs="images"
                      ref="slideblock1"
                      @success="onSuccess"
                      @fail="onFail"
                      @refresh="onRefresh"
                      :slider-text="text"
                    ></slide-verify>
                  </el-row>
                </el-form-item>
                <el-form-item>
                  <div style="text-align:left">
                    <el-checkbox v-model="checked">&nbsp;</el-checkbox>我已阅读并同意
                    <span
                      @click="dataSourceVisible=!dataSourceVisible"
                      class="xieyi"
                    >《大赛网站会员注册协议》</span>
                  </div>
                  <el-button
                    type="success"
                    style="background:#0c70fc;width:100%;"
                    :disabled="registerDisabled"
                    @click="registerForm('registerFormEmail')"
                  >立即注册</el-button>
                  <div style="float:left">
                    <a href="javascript:void(0)" @click="alter">注册<span v-text="navigation"></span>用户</a>
                  </div>
                  <div style="float:right" >
                    已有账号？
                    <a href="javascript:void(0)" @click="loginIn">马上登录</a>
                    <!-- 使用第三方账号登录 -->
                  </div>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="手机号注册" name="phoneSignUp">
              <el-form
                :model="registerFormPhone"
                status-icon
                :rules="rules"
                ref="registerFormPhone"
                style="min-height:250px"
              >
                <el-form-item prop="phonenumber">
                  <el-input
                    type="text"
                    v-model.number="registerFormPhone.phonenumber"
                    placeholder="请输入手机号"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="code">
                  <el-row>
                    <!-- <el-col :span="16">
                      <el-input
                        v-model="registerFormPhone.code"
                        auto-complete="off"
                        placeholder="请输入图片验证码"
                        style="width: 100%"
                      ></el-input>
                    </el-col>
                    <el-col :span="8">
                      <div class="login-code" style="height: 50px;">
                        <img
                          :src="codeUrl"
                          @click="getCode"
                          class="login-code-img"
                          style="width:100%;height:50px;border-r"
                        />
                      </div>
                    </el-col>-->
                    <slide-verify
                      v-if="activeName === 'phoneSignUp'"
                      :key="2"
                      :l="42"
                      :r="10"
                      :w="verifyWhite"
                      :h="150"
                      :imgs="images"
                      ref="slideblock2"
                      @success="onSuccess"
                      @fail="onFail"
                      @refresh="onRefresh"
                      :slider-text="text"
                    ></slide-verify>
                  </el-row>
                </el-form-item>

                <el-form-item prop="activationOrder">
                  <el-row>
                    <el-col :span="16">
                      <el-input
                        v-model="registerFormPhone.activationOrder"
                        auto-complete="autoComplete"
                        placeholder="请输入短信验证码"
                        style="width:100%;"
                      ></el-input>
                    </el-col>
                    <el-col :span="8">
                      <div class="login-code">
                        <el-button
                          :disabled="isDisabledPRegister"
                          @click="registerCaptcha"
                          style="padding: 0 !important;"
                        >
                          <span>{{buttonNamePRegister}}</span>
                        </el-button>
                      </div>
                    </el-col>
                  </el-row>
                </el-form-item>

                <el-form-item>
                  <div style="text-align:left">
                    <el-checkbox v-model="checked">&nbsp;</el-checkbox>我已阅读并同意
                    <span
                      @click="dataSourceVisible=!dataSourceVisible"
                      class="xieyi"
                    >《大赛网站会员注册协议》</span>
                  </div>
                  <el-button
                    type="success"
                    style="background:#0c70fc;width:100%;"
                    :disabled="registerDisabled"
                    @click="registerForm('registerFormPhone')"
                  >立即注册</el-button>
                  <div style="float:left">
                    <a href="javascript:void(0)" @click="alter">注册<span v-text="navigation"></span>用户</a>
                  </div>
                  <div style="float:right" >
                    已有账号？
                    <a href="javascript:void(0)" @click="loginIn">马上登录</a>
                    <!-- 使用第三方账号登录 -->
                  </div>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-container>
    </el-dialog>
    <el-dialog
      key="login"
      title="用户登录"
      custom-class="login-form"
      :visible.sync="loginVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
      <el-container v-if="loginVisible && !resetPwdVisible">
        <div class="reg">
          <el-tabs v-model="activeName">
            <el-tab-pane label="密码登录" name="emailSignUp">
              <el-form
                :model="loginFormEmail"
                status-icon
                :rules="rules"
                ref="loginFormEmail"
                style="min-height:250px"
              >
                <el-form-item prop="email">
                  <el-input type="text" v-model="loginFormEmail.email" placeholder="请输入邮箱/账号"></el-input>
                </el-form-item>
                <el-form-item prop="pass">
                  <el-input
                    type="password"
                    v-model="loginFormEmail.pass"
                    placeholder="请输入密码"
                    auto-complete="new-password"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="code">
                  <el-row>
                    <!-- <el-col :span="16">
                      <el-input
                        v-model="loginFormEmail.code"
                        auto-complete="off"
                        placeholder="请输入图片验证码"
                        style="width: 100%"
                      ></el-input>
                    </el-col>
                    <el-col :span="8">
                      <div class="login-code" style="height: 50px;">
                        <img
                          :src="codeUrl"
                          @click="getCode"
                          class="login-code-img"
                          style="width:100%;height:50px;border-r"
                        />
                      </div>
                    </el-col>-->
                    <slide-verify
                      v-if="activeName === 'emailSignUp'"
                      :key="3"
                      :l="42"
                      :r="10"
                      :w="verifyWhite"
                      :h="155"
                      :imgs="images"
                      ref="slideblock3"
                      @success="onSuccess"
                      @fail="onFail"
                      @refresh="onRefresh"
                      :slider-text="text"
                    ></slide-verify>
                  </el-row>
                </el-form-item>
                <el-form-item>
                  <el-row :gutter="20">
                    <el-col :span="8">
                      <a href="javascript:void(0)" @click="resetPwd">忘记密码</a>
                    </el-col>
                    <el-col :span="16" style="text-align:right">
                      还没有账号？
                      <a href="javascript:void(0)" @click="register">快速注册</a>
                    </el-col>
                  </el-row>
                  <el-button
                    type="success"
                    style="background:#0c70fc;width:100%;"
                    @click="loginForm('loginFormEmail')"
                  >登 录</el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="手机登录" name="phoneSignUp">
              <el-form
                :model="loginFormPhone"
                status-icon
                :rules="rules"
                ref="loginFormPhone"
                style="min-height:250px"
              >
                <el-form-item prop="phonenumber">
                  <el-input
                    type="text"
                    v-model.number="loginFormPhone.phonenumber"
                    placeholder="请输入手机号"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="code">
                  <el-row>
                    <!-- <el-col :span="16">
                      <el-input
                        v-model="loginFormPhone.code"
                        auto-complete="off"
                        placeholder="请输入图片验证码"
                        style="width: 100%"
                      ></el-input>
                    </el-col>
                    <el-col :span="8">
                      <div class="login-code" style="height: 50px;">
                        <img
                          :src="codeUrl"
                          @click="getCode"
                          class="login-code-img"
                          style="width:100%;height:50px;"
                        />
                      </div>
                    </el-col>-->
                    <slide-verify
                      v-if="activeName === 'phoneSignUp'"
                      :key="4"
                      :l="42"
                      :r="10"
                      :w="verifyWhite"
                      :h="155"
                      :imgs="images"
                      ref="slideblock4"
                      @success="onSuccess"
                      @fail="onFail"
                      @refresh="onRefresh"
                      :slider-text="text"
                    ></slide-verify>
                  </el-row>
                </el-form-item>

                <el-form-item prop="activationOrder">
                  <el-row>
                    <el-col :span="16">
                      <el-input
                        v-model="loginFormPhone.activationOrder"
                        auto-complete="autoComplete"
                        placeholder="验证码"
                        style="width:100%;"
                      ></el-input>
                    </el-col>
                    <el-col :span="8">
                      <div class="login-code">
                        <el-button
                          :disabled="isDisabledPLogin"
                          @click="loginCaptcha"
                          style="padding: 0 !important;"
                        >
                          <span>{{buttonNamePLogin}}</span>
                        </el-button>
                      </div>
                    </el-col>
                  </el-row>
                </el-form-item>

                <el-form-item>
                  <div style="text-align:right">
                    还没有账号？
                    <a href="javascript:void(0)" @click="register">快速注册</a>
                  </div>
                  <el-button
                    type="success"
                    style="background:#0c70fc;width:100%;"
                    @click="loginForm('loginFormPhone')"
                  >登 录</el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-container>
    </el-dialog>

    <resetPwdForm :resetPwdVisible="resetPwdVisible"></resetPwdForm>
    <registerAgreement :dataSourceVisible="dataSourceVisible" @checkBox="toCheck"></registerAgreement>
  </div>
</template>

<script>
import {getFrontMenuMap} from '../api/register/index'
import resetPwdForm from './resetPwd'
import RegisterAgreement from './RegisterAgreement'
import {setToken} from '../utils/auth'
import {encrypt} from '../utils/encryption'
import { Message } from 'element-ui'
export default {
  components: { resetPwdForm, RegisterAgreement },
  watch: {
    '$store.state.loginVisible': function (newFlag, oldFlag) {
      if (!newFlag) {
        return
      }
      this.delRedisVerification()
      this.setSessionValues(this.sessionKey)
      this.getSessionKey()
      this.setVerification()
      this.getImages()
    },
    '$store.state.registerFormVisible': function (newFlag, oldFlag) {
      if (!newFlag) {
        return
      }
      this.delRedisVerification()
      this.setSessionValues(this.sessionKey)
      this.getSessionKey()
      this.setVerification()
      this.getImages()
    }
  },
  data () {
    /* 登陆注册验证 */
    var email = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的邮箱格式'))
        }
      }, 100)
    }
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'))
      } else {
        if (this.registerFormEmail.checkPass !== '') {
          this.$refs.registerFormEmail.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.registerFormEmail.pass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    var checkPhone = (rule, value, callback) => {
      // const phoneReg = /^1[3|4|5|7|8|9][0-9]{9}$/
      // const phoneReg = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57]|19[0-9]|16[0-9])[0-9]{8}$/
      const phoneReg = /^((13[0-9])|(14([0-1]|[4-9]))|(15([0-3]|[5-9]))|(16(2|[5-7]))|(17[1-9])|(18[0-9])|(19[0|1|2|3])|(19[5-9]))\d{8}$/
      if (!value) {
        return callback(new Error('手机号不能为空'))
      }
      setTimeout(() => {
        // Number.isInteger是es6验证数字是否为整数的方法,实际输入的数字总是识别成字符串
        // 所以在前面加了一个+实现隐式转换

        if (!Number.isInteger(+value)) {
          callback(new Error('请输入数字值'))
        } else {
          if (phoneReg.test(value)) {
            // 查询用户是否存在如果存在返回信息
            this.getUserByPhone(value, callback)
            // callback();
          } else {
            callback(new Error('手机号格式不正确'))
          }
        }
      }, 100)
    }
    return {
      verification: null,
      sessionKey: 'verificationCode',
      sessionValue: null,
      navigation: '学校',
      title: '普通',
      resetPwdVisible: false,
      channelList: [],
      queryParams: {
        siteId: this.channelId,
        parentId: undefined,
        url: undefined
      },
      text: '向右拖动滑块填充拼图', // 滑块底部文字
      codeStatus: false,
      /* 邮箱注册 */
      codeUrl: '',
      buttonNamePLogin: '发送短信',
      buttonNamePRegister: '发送短信',
      images: [],
      isDisabledPLogin: false,
      isDisabledPRegister: false,
      registerDisabled: false,
      timePLogin: 60,
      timePRegister: 60,
      checked: false,
      dataSourceVisible: false,
      roles: [],
      registerFormEmail: {
        email: '',
        pass: '',
        checkPass: '',
        userType: '01',
        code: '',
        uuid: '',
        start: '0'
      },
      // 手机
      registerFormPhone: {
        phonenumber: '',
        activationOrder: '',
        remark: '', // 缺少字段,备注代替(uuid) 无影响
        userType: '01',
        start: '0'
      },
      // 登录
      // 邮箱
      loginFormEmail: {
        email: '',
        pass: ''
      },
      // 手机
      loginFormPhone: {
        phonenumber: '',
        activationOrder: '',
        remark: '' // 缺少字段,备注代替(uuid) 无影响
      },
      activeName: 'phoneSignUp',
      rules: {
        email: [],
        pass: [{ validator: validatePass, trigger: 'blur' }, {
          pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,30}$/,
          message: '密码长度为8-30位，且包含数字、符号、字母'
        }],
        checkPass: [{ validator: validatePass2, trigger: 'blur' }, {
          pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,30}$/,
          message: '密码长度为8-30位，且包含数字、符号、字母'
        }],
        phonenumber: [{ validator: checkPhone, trigger: 'blur' }],
        activationOrder: [
          { required: true, trigger: 'change', message: '验证码不能为空' }
        ]
        /* code: [{ required: true, trigger: "change", message: "验证码不能为空" }] */
      },
      verifyWhite: 355
    }
  },
  computed: {
    loginVisible: {
      get: function () {
        return this.$store.state.loginVisible
      }
    },
    registerFormVisible: {
      get: function () {
        return this.$store.state.registerFormVisible
      }
    }
  },
  created () {
    /* this.getCode(); */
    /* this.getCookie(); */
    this.setSessionValues(this.sessionKey)
    this.getSessionKey()
    this.setVerification()
    this.getImages()
  },
  mounted () {
    let flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
    if (flag) {
      this.verifyWhite = 260
    }
  },
  methods: {
    /* 注册登录  使用验证码方式 */
    /* getCode() {
      var api = this.systemURL + "/actuator/before/createCapcha";
      var params = {};
      this.axios.post(api, params).then(res => {
        this.codeUrl = "data:image/gif;base64," + res.data.img;
        this.registerFormEmail.uuid = res.data.uuid;
        this.registerFormPhone.uuid = res.data.uuid;
        this.loginFormEmail.uuid = res.data.uuid;
        this.loginFormPhone.uuid = res.data.uuid;
      });

        getCodeImg().then(res => {
        this.codeUrl = "data:image/gif;base64," + res.img;
        this.loginForm.uuid = res.uuid;
      });
    }, */
    /* 获取图片库 */
    // 在session中存放唯一的识别码
    setSessionValues (obj) {
      console.log(obj)
      window.sessionStorage.setItem(obj, this.getRandomCode())
    },
    // 生成随机识别码
    getRandomCode (length) {
      length = length || 32
      var text = ''
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      for (var i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length))
      }
      console.log(text)
      return text
    },
    getSessionKey () {
      this.sessionValue = window.sessionStorage.getItem(this.sessionKey)
    },
    setVerification () {
      var api = this.systemURL + '/actuator/before/insertVerification?sessionKey=' + this.sessionValue
      this.axios.get(api, null).then(res => {
        this.verification = res.data
      })
    },
    delRedisVerification () {
      window.sessionStorage.removeItem(this.sessionKey)
      var api = this.systemURL + '/actuator/before/delRedisVerification?sessionKey=' + this.sessionValue
      this.axios.get(api, null).then(res => {
        if (res.data != true) {
          this.alter()
        }
      })
    },
    alter () {
      if (this.title === '普通') {
        this.title = this.navigation
        this.navigation = '普通'
        this.registerFormEmail.start = 1
        this.registerFormPhone.start = 1
      } else {
        this.title = this.navigation
        this.navigation = '学校'
        this.registerFormEmail.start = 0
        this.registerFormPhone.start = 0
      }
      // this.$store.commit('registerFormVisibleMutations', false)
      // this.$store.commit('registerFormVisibleMutations', true)
    },
    getImages () {
      var api = this.siteURL + '/actuator/storage/list?businessId=-1'
      this.axios.get(api, { businessId: '-1' }).then(res => {
        if (res.data.code === 500) {
          this.$message.error(res.data.msg)
          return
        }
        this.images = ((res.data && res.data.rows) || []).map(item => {
          return item.path
        })
      })
    },
    // 根据手机号码获取用户，判断用户是否注册
    getUserByPhone (phone, callback) {
      var api = this.systemURL + '/actuator/before/getUserByPhone?phone=' + phone
      let that = this
      /* this.getCode(); */
      this.axios.get(api, {}).then((res) => {
        if (res.data.data != null) {
          if (that.registerFormVisible) {
            callback(new Error('用户已注册'))
          } else if (this.loginVisible) {
            callback()
          } else {
          }
        } else {
          // 注册模块中如果用户没有注册提示未注册
          if (this.loginVisible) {
            callback(new Error('用户未注册'))
          } else if (this.registerFormVisible) {
            callback()
          } else {
          }
        }
      })
    },
    registerCaptcha () {
      // 发送手机验证码 注册
      var code = this.registerFormPhone.code
      let phonenumber = this.$data.registerFormPhone.phonenumber
      let mailReg = /^1[3456789]\d{9}$/
      if (!mailReg.test(phonenumber)) {
        this.$message.warning('请确认手机号是否正确')
        return
      } else if (!this.codeStatus) {
        this.$message.warning('图片验证未成功，请验证')
        return
      }

      var api = this.systemURL + '/actuator/before/getCaptcha'
      var params = {
        phonenumber: phonenumber,
        siteId: this.siteId
      }
      this.axios.post(api, params).then(res => {
        if (res.data.code == 500) {
          this.$message.error(res.data.msg)
          return
        }
        this.$message.success('已发送手机验证码，请查收')
        this.isDisabledPRegister = true
        this.registerFormPhone.remark = res.data.uuid
        let interval = window.setInterval(() => {
          this.buttonNamePRegister = '(' + this.timePRegister + '秒)后重发'
          --this.timePRegister
          if (this.timePRegister < 0) {
            this.buttonNamePRegister = '重新发送'
            this.timePRegister = 60
            this.isDisabledPRegister = false
            window.clearInterval(interval)
          }
        }, 1000)
      })
    },
    loginCaptcha () {
      // 发送手机验证码 登录
      var code = this.loginFormPhone.code
      let phonenumber = this.$data.loginFormPhone.phonenumber
      let mailReg = /^1[3456789]\d{9}$/
      if (!mailReg.test(phonenumber)) {
        this.$message.warning('请确认手机号是否正确')
        return
      } else if (!this.codeStatus) {
        this.$message.warning('图片验证未成功，请验证')
        return
      } /* else if (!code) {
        this.$message.warning("请填写图片验证码");
        return;
      } */

      var api = this.systemURL + '/actuator/before/getCaptcha'
      var params = {
        siteId: this.siteId,
        phonenumber: this.$data.loginFormPhone.phonenumber,
        code: code,
        uuid: this.registerFormPhone.uuid
      }
      /* this.getCode(); */
      this.axios.post(api, params).then(res => {
        if (res.data.code == 500) {
          this.$message.error(res.data.msg)
          return
        }
        this.$message.success('已发送手机验证码，请查收')
        this.isDisabledPLogin = true
        this.loginFormPhone.remark = res.data.uuid
        let interval = window.setInterval(() => {
          this.buttonNamePLogin = '(' + this.timePLogin + '秒)后重发'
          --this.timePLogin
          if (this.timePLogin < 0) {
            this.buttonNamePLogin = '重新发送'
            this.timePLogin = 60
            this.isDisabledPLogin = false
            window.clearInterval(interval)
          }
        }, 1000)
      })
    },
    registerForm (formName) {
      if (!this.checked) {
        this.$message.warning('请查看并勾选《大赛网站会员注册协议》')
        return
      }
      if (!this.codeStatus) {
        this.$message({
          message: '图片验证未成功，请验证',
          type: 'error'
        })
        return
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.registerDisabled = true
          // 信息填写完毕发送邮件
          var api = this.systemURL + '/actuator/before/registeredAdd?siteId=' + this.siteId
          if (formName == 'registerFormEmail') {
            //
            var params = {
              verification: this.verification,
              sessionKey: this.sessionValue,
              email: this.$data.registerFormEmail.email,
              password: this.$data.registerFormEmail.pass,
              userType: this.registerFormEmail.userType,
              code: this.registerFormEmail.code,
              uuid: this.registerFormEmail.uuid,
              roleId: this.registerFormEmail.start
            }
          } else {
            // 手机短信
            var params = {
              verification: this.verification,
              sessionKey: this.sessionValue,
              phonenumber: this.$data.registerFormPhone.phonenumber,
              activationOrder: this.$data.registerFormPhone.activationOrder,
              remark: this.registerFormPhone.remark,
              userType: this.registerFormPhone.userType,
              roleId: this.registerFormPhone.start
            }
          }
          this.axios.post(api, params).then(res => {
            /* this.getCode(); */
            if (res.data.code == 500) {
              this.$message.error(res.data.msg)
            } else if (res.data.code == 200) {
              if (formName == 'registerFormEmail') {
                this.$confirm('邮箱已注册，请登陆邮箱激活账号', '提示', {
                  confirmButtonText: '确定',
                  type: 'success'
                })
              } else {
                Message({
                  message: '注册成功，将自动登录',
                  type: 'success',
                  duration: 2 * 1000
                })
                // 手机注册完成自动登陆
                var logiApi = this.systemURL + '/actuator/before/loginByReg?siteId=' + this.siteId
                // 手机短信
                var params = {
                  phonenumber: this.$data.registerFormPhone.phonenumber
                }
                this.axios.post(logiApi, params).then(res => {
                  if (res.data.code == 200) {
                    this.$store.commit('setUser', res.data.user)
                    setToken(res.data.token.access_token)
                    this.codeStatus = false
                    this.getPowerMenu()
                  }
                  if (res.data.code == 500) {
                    this.$message.error(res.data.msg)
                  }
                })
              }
            } else {
              this.$message.warning(res.data.msg)
            }
            this.registerDisabled = false
            this.handleClose()
            this.codeStatus = false
            this.$refs.slideblock1 && this.$refs.slideblock1.reset()
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    loginForm (formName) {
      if (!this.codeStatus) {
        this.$message({
          message: '图片验证未成功，请验证',
          type: 'error'
        })
        return
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 信息填写完毕发送邮件
          var api = this.systemURL + '/actuator/before/loginWebsite?siteId=' + this.siteId
          if (formName == 'loginFormEmail') {
            // 邮件
            var params = {
              verification: this.verification,
              sessionKey: this.sessionValue,
              email: this.$data.loginFormEmail.email,
              password: encrypt(this.$data.loginFormEmail.pass),
              code: this.loginFormEmail.code,
              uuid: this.loginFormEmail.uuid
            }
            let phonenumber = this.$data.loginFormEmail.email
            let mailReg = /^1[3456789]\d{9}$/
            if (mailReg.test(phonenumber)) {
              this.$store.commit('setLoginMethod', 'phone')
            } else {
              this.$store.commit('setLoginMethod', 'email')
            }
          } else {
            // 手机短信
            var params = {
              verification: this.verification,
              sessionKey: this.sessionValue,
              phonenumber: this.$data.loginFormPhone.phonenumber,
              activationOrder: this.$data.loginFormPhone.activationOrder,
              remark: this.loginFormPhone.remark
            }
            this.$store.commit('setLoginMethod', 'phone')
          }
          /* this.getCode(); */
          this.axios.post(api, params).then(res => {
            if (res.data.code == 200) {
              this.$store.commit('setUser', res.data.user)
              setToken(res.data.token.access_token)
              this.codeStatus = false
              this.$message({
                message: '登录成功',
                type: 'success',
                duration: 1000
              })
              this.getPowerMenu()
              // alert("必经之路");
              // console.log("用户信息",res.data.data);
            }
            if (res.data.code == 500) {
              this.delRedisVerification()
              this.setSessionValues(this.sessionKey)
              this.getSessionKey()
              this.setVerification()
              this.codeStatus = false
              this.$refs.slideblock3 && this.$refs.slideblock3.reset()
              this.$message.error(res.data.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getPowerMenu () {
      getFrontMenuMap(this.authURL).then(res => {
        this.$store.commit('setPwoerMenuIds', res.frontMenuMap)
        this.codeStatus = false
        this.handleClose()
      })
    },
    resetPwd () {
      this.resetPwdVisible = true
    },
    loginIn () {
      this.$store.commit('registerFormVisibleMutations', false)
      this.$store.commit('loginVisibleMutations', true)
    },
    register () {
      this.delRedisVerification()
      this.setSessionValues(this.sessionKey)
      this.getSessionKey()
      this.setVerification()
      this.$store.commit('registerFormVisibleMutations', true)
      this.$store.commit('loginVisibleMutations', false)
    },
    handleClose () {
      /* 滚动验证状态更新 */
      this.codeStatus = false
      /* 滚动验证刷新图片 */
      if (this.loginVisible === true) {
        this.$refs.slideblock3 && this.$refs.slideblock3.reset()
        this.$refs.slideblock4 && this.$refs.slideblock4.reset()
      }
      if (this.registerFormVisible === true) {
        this.$refs.slideblock1 && this.$refs.slideblock1.reset()
        this.$refs.slideblock2 && this.$refs.slideblock2.reset()
      }

      this.$store.commit('registerFormVisibleMutations', false)
      this.$store.commit('loginVisibleMutations', false)
      /* 清空所有表单信息 */
      this.registerFormEmail = {
        email: '',
        pass: '',
        checkPass: '',
        userType: '01',
        code: '',
        uuid: ''
      }
      // 手机
      this.registerFormPhone = {
        phonenumber: '',
        activationOrder: '',
        remark: '', // 缺少字段,备注代替(uuid) 无影响
        userType: '01',
        code: '',
        uuid: ''
      }
      // 登录
      // 邮箱
      this.loginFormEmail = {
        email: '',
        pass: ''
      }
      // 手机
      this.loginFormPhone = {
        phonenumber: '',
        activationOrder: '',
        remark: '' // 缺少字段,备注代替(uuid) 无影响
      }
    },
    toCheck () {
      this.checked = true
    },
    /* 滑动验证相关回调函数 */
    onSuccess () {
      /* 更改滚动验证状态 */

      this.codeStatus = true
      this.$message({
        message: '图片验证成功',
        type: 'success',
        duration: 2000
      })
    },
    onFail () {
      this.$message({
        message: '图片验证失败，请重新验证',
        type: 'error',
        duration: 2000
      })
      this.delRedisVerification()
      this.setSessionValues(this.sessionKey)
      this.getSessionKey()
      this.setVerification()
      this.codeStatus = false
    },
    onRefresh () {
      /* console.log("按钮刷新的回调"); */
      this.delRedisVerification()
      this.setSessionValues(this.sessionKey)
      this.getSessionKey()
      this.setVerification()
      this.codeStatus = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.grid-content {
  height: 60px;
}
.el-menu.el-menu--horizontal {
  border-bottom: 0px;
}
/* 去掉下方横线 */
.el-menu::after {
  display: none;
}
/* 背景颜色设置 */
.el-menu-item.is-active {
  background-image: linear-gradient(to right, #133c73, #0c70fc);
  color: #fff !important;
}
/* 去掉border-bottom样式 */
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 0px !important;
}
/* 导航栏字体大小 */
.el-menu-item {
  font-size: 15px;
  padding: 0 14px;
}
/* ‘我要参赛’button样式 */
.toCompetition-button {
  width: 118px;
  font-size: 12px;
  background-image: url("../assets/banner/toCompetition.png");
  background-repeat: no-repeat;
  background-position: -4px 6px;
}
/* 我要参赛字体样式 */
.el-button--text {
  color: #fff;
}
.register {
  color: #0c70fc;
  cursor: pointer;
}
.register:hover {
  color: #2c2fd6;
}
</style>

<style >
.reg {
  width: 100%;
}
.reg .el-tabs__nav {
  width: 100%;
  float: none;
}
.reg .el-tabs__active-bar {
  background-color: #e4e7ed;
  height: 0px;
}
.reg .el-radio-group {
  float: left;
  position: relative;
  top: 12px;
}
.reg .el-tabs__item {
  padding-left: 20px;
  background: #f9f9f9;
  width: 50%;
  text-align: center;
  font-size: 17px !important;
  background-repeat: no-repeat !important;
  background-position: 22px 15px !important;
  margin-bottom: 1rem;
  height: 60px;
  line-height: 60px;
}
/* 每个都要加，否则部署后不生效 */
#tab-emailSignUp {
  background-image: url("../assets/icon/邮箱.png") !important;
  background-repeat: no-repeat !important;
  background-position: 10px 16px !important;
}
#tab-emailSignUp.is-active {
  background-image: url("../assets/icon/邮箱-默认.png") !important;
  background-repeat: no-repeat !important;
  background-position: 10px 16px !important;
}
#tab-phoneSignUp {
  background-image: url("../assets/icon/手机.png") !important;
  background-repeat: no-repeat !important;
  background-position: 10px 16px !important;
}
#tab-phoneSignUp.is-active {
  background-image: url("../assets/icon/手机-默认.png") !important;
  background-repeat: no-repeat !important;
  background-position: 10px 16px !important;
}
.reg .el-tabs__item.is-active {
  color: white !important;
  background: #0c70fc !important;
}
.reg .el-tabs__nav-wrap::after {
  background-color: white;
}
.el-dialog .el-dialog__body {
  padding: 30px 60px !important;
}
/* .el-dialog__headerbtn.el-dialog__headerbtn .el-dialog__close {
  display: none;
} */
.login .el-form-item__content .el-button--primary {
  width: 100%;
}
.login-code .el-button {
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding: 0;
  color: #0c70fc;
  background-color: #eeeeee;
}
/*  */
.el-radio-button--small .el-radio-button__inner {
  padding: 5px 5px !important;
}
.reg .el-input__inner {
  height: 50px;
  line-height: 50px;
  background-color: #fafafa;
}
.reg a {
  text-decoration: none;
  color: #0c70fc;
}
.xieyi {
  color: #fcae48;
  cursor: pointer;
}

@media screen and (max-width: 785px) {
  #tab-emailSignUp {
    background-image: url("../assets/icon/邮箱.png") !important;
    background-repeat: no-repeat !important;
    background-position: 0px 15px !important;
  }
  #tab-emailSignUp.is-active {
    background-image: url("../assets/icon/邮箱-默认.png") !important;
    background-repeat: no-repeat !important;
    background-position: 0px 15px !important;
  }
  #tab-phoneSignUp {
    background-image: url("../assets/icon/手机.png") !important;
    background-repeat: no-repeat !important;
    background-position: 0px 15px !important;
  }
  #tab-phoneSignUp.is-active {
    background-image: url("../assets/icon/手机-默认.png") !important;
    background-repeat: no-repeat !important;
    background-position: 0px 15px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue